var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-icon',_vm._b({staticClass:"btn--icon-rounded",attrs:{"icon_name":_vm.icon_name}},'button-icon',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }